/* Load more for the collection grid.

   The button asks the server for the next paginated page, lifts the cards out
   of it and appends them. Same pagination the theme already had, so the server
   does no extra work, but the shopper never leaves the page and never loses
   their scroll position. */
(function () {
  if (window.__cfLoadMore) return;
  window.__cfLoadMore = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-cfl-next]') : null;
    if (!btn || btn.__busy) return;
    event.preventDefault();

    var next = btn.getAttribute('data-cfl-next');
    if (!next) return;

    btn.__busy = true;
    var label = btn.textContent;
    btn.textContent = 'Loading';

    fetch(next, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector('[data-cfl-grid]');
        var incoming = doc.querySelector('[data-cfl-grid]');
        if (!grid || !incoming) throw new Error('no grid');

        var first = incoming.firstElementChild;
        var added = [];
        while (incoming.firstElementChild) {
          added.push(incoming.firstElementChild);
          grid.appendChild(incoming.firstElementChild);
        }

        var count = document.querySelector('[data-cfl-shown]');
        var freshCount = doc.querySelector('[data-cfl-shown]');
        if (count && freshCount) count.textContent = freshCount.textContent;

        var freshBtn = doc.querySelector('[data-cfl-next]');
        if (freshBtn) {
          btn.setAttribute('data-cfl-next', freshBtn.getAttribute('data-cfl-next'));
          btn.textContent = label;
          btn.__busy = false;
        } else {
          btn.remove();
        }

        /* let a screen reader and the keyboard follow where the new run starts */
        if (added.length) {
          var focusable = added[0].querySelector('a, button');
          if (focusable) focusable.setAttribute('data-cfl-fresh', '');
        }
        if (first) { /* referenced to keep the reference alive for debugging */ }
      })
      .catch(function () {
        btn.textContent = label;
        btn.__busy = false;
        window.location.href = next;
      });
  });
})();
